import {
    SET_CERTIFICATS_LOADING,
    SET_CERTIFICATS_ERROR,
    FETCH_CERTIFICATS_SUCCESS,
    FETCH_CERTIFICAT_PLACEHOLDERS_SUCCESS,
    DELETE_CERTIFICAT_SUCCESS,
    GENERATE_CERTIFICAT_PDF_SUCCESS,
    CREATE_CERTIFICAT_SUCCESS,
    UPDATE_CERTIFICAT_SUCCESS,
    CREATE_CERTIFICAT_VERSION_SUCCESS,
    UPDATE_CERTIFICAT_LIFECYCLE_SUCCESS,
} from "../actions/certificatsActions";

const initialState = {
    loading: false,
    error: null,
    certificats: [],
    placeholders: [],
    generateLoading: false,
    lastGenerated: null,
};

export default function certificatsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CERTIFICATS_LOADING:
            return { ...state, loading: action.payload };

        case SET_CERTIFICATS_ERROR:
            return { ...state, error: action.payload };

        case FETCH_CERTIFICATS_SUCCESS:
            return { ...state, certificats: action.payload || [], error: null };

        case FETCH_CERTIFICAT_PLACEHOLDERS_SUCCESS:
            return { ...state, placeholders: action.payload || [] };

        case CREATE_CERTIFICAT_SUCCESS:
        case UPDATE_CERTIFICAT_SUCCESS:
        case CREATE_CERTIFICAT_VERSION_SUCCESS:
        case UPDATE_CERTIFICAT_LIFECYCLE_SUCCESS:
            return { ...state, error: null };

        case DELETE_CERTIFICAT_SUCCESS:
            return {
                ...state,
                certificats: state.certificats.filter((item) => item.id !== action.payload),
                error: null,
            };

        case GENERATE_CERTIFICAT_PDF_SUCCESS:
            return {
                ...state,
                generateLoading: false,
                lastGenerated: action.payload?.document || null,
                error: null,
            };

        default:
            return state;
    }
}
